// import Config from 'react-native-config'
import axios from "axios";
import { BASEURL } from "../../utils";

var instance = axios.create({
  baseURL: BASEURL,
  timeout: 120000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
  },
});

// Request interceptor
instance.interceptors.request.use(
  (request) => request,
  (error) => new Error(error)
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => error.response
);

export default instance;
